import React, { useContext, useEffect } from 'react';
import ConversationHeader from './ConversationHeader';
import MessageEditor from './MessageEditor';
import Message from './Message';
import { BaseContext } from '../contexts/baseContext';

export default function ConversationInterface({ messages, contact, conversationResize}) {
  const { conversationBodyHeight } = useContext(BaseContext);

  const generateIndexedMessage = (message) => {
    let msgIndexed = null;
    let author = null;

    if (message.idMessageIndexed !== null) {
      msgIndexed = messages.find(msg => msg.id === message.idMessageIndexed);

      if (msgIndexed !== null) {
        author = msgIndexed.type === "sended" ? "You":contact.nom;
      }
    }

    return { msgIndexed, author };
  }

  useEffect(() => {
    // managing of progressive loading of images
    let imagesToLoad = document.querySelectorAll('img[data-src]');
    const loadImages = (image) => {
      console.log(image);
      image.setAttribute('src', image.getAttribute('data-src'));
      image.onload = () => {
        image.removeAttribute('data-src');
      };
    };

    for (let image of imagesToLoad) {
      loadImages(image);
    }
  });

  return (
    <>
      <ConversationHeader
        nom={contact.nom}
      />

      <div className="section-conversation-body" style={{ height: `${conversationBodyHeight}px` }} >
        {
          messages.map(message => {
            return (
              <Message message={message} messageIndexed={generateIndexedMessage(message)} key={message.id} />
            )
          })
        }
      </div>

      <MessageEditor
        conversationResize={conversationResize}
        messages={messages}
        nameContact={contact.nom}
      />
    </>
  );
}
